<template>
  <div>
    <a-card style="margin-top:20px;">
      <TableView
        :columns="tableColumns"
        tableCardTitle="D&B LOOKUP"
        :scroll="{ x: 800 }"
        :data="tableData"
      >
        <template v-slot:radio="{ tableRow }">
          <a-radio-group v-model="value" @change="onChange">
            <a-radio :value="tableRow.dunsNumber"></a-radio>
          </a-radio-group>
        </template>
      </TableView>
      <a-button type="primary" @click="handleSubmit">
        提交
      </a-button>
    </a-card>
  </div>
</template>
<script>
import { TableView } from 'lxfintech-fe'
import { mapGetters } from 'vuex'
import { getGlobalDetail } from '../api'
export default {
  data() {
    const tableColumns = [
      {
        width: 30,
        dataIndex: 'radio',
        title: '',
        scopedSlots: { customRender: 'radio' },
      },
      {
        width: 130,
        title: 'Duns Number',
        dataIndex: 'dunsNumber',
      },
      {
        width: 170,
        title: 'Registration Number',
        dataIndex: 'registrationNumber',
      },
      {
        width: 220,
        title: 'Type Description',
        dataIndex: 'typeDescription',
      },
      {
        width: 220,
        title: 'Business Name',
        dataIndex: 'businessName',
      },
      {
        width: 260,
        title: 'Address',
        dataIndex: 'address',
      },
      {
        width: 140,
        title: 'City',
        dataIndex: 'city',
      },
      {
        width: 200,
        title: 'State/Province/Region',
        dataIndex: 'state',
      },
      {
        width: 120,
        title: 'Country Code',
        dataIndex: 'countryCode',
      },
      {
        width: 120,
        title: 'Postal Code',
        dataIndex: 'postalCode',
      },
      {
        width: 120,
        title: 'Telephone #',
        dataIndex: 'telephone',
      },
      {
        width: 120,
        title: 'URL',
        dataIndex: 'url',
      },
      {
        width: 130,
        title: 'Confidence Code',
        dataIndex: 'confidenceCode',
      },
      {
        width: 120,
        title: 'Match Grade',
        dataIndex: 'matchGrade',
      },
      {
        width: 120,
        title: 'Trade Style',
        dataIndex: 'tradeStyle',
      },
      {
        width: 130,
        title: 'Operating Status',
        dataIndex: 'operatingStatus',
      },
      {
        width: 120,
        title: 'isStandalone',
        dataIndex: 'isStandalone',
      },
    ]
    return {
      radio: '',
      value: '',
      tableData: [],
      tableColumns,
    }
  },
  components: {
    TableView,
  },
  computed: {
    ...mapGetters('app', ['bureauReportBasicInfo']),
  },
  mounted() {
    this._getCrmDetail()
  },
  methods: {
    onChange(e) {
      this.radio = e.target.value
    },
    handleSubmit() {
      if (this.radio) {
        this.$router.push({
          name: 'mechanism-report-add',
          params: { customerId: this.$route.params.id },
          query: {
            dunsNumber: this.radio,
          },
        })
      } else {
        this.$message.warning('请选择')
      }
    },
    async _getCrmDetail() {
      try {
        const { id } = this.bureauReportBasicInfo
        const { data } = await getGlobalDetail(id)
        this.tableData = data
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
